import React, { useState } from 'react';
import { ILegalPhaseTemplateFullObject } from '../Interfaces/ILegalPhaseTemplate';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { Add, Delete, Edit } from '@mui/icons-material';
import { TextModuleSelector } from '../TextModule/TextModuleSelector';

interface IProps {
  currentPhase: ILegalPhaseTemplateFullObject;
  currentPhaseEdit: ILegalPhaseTemplateFullObject;
  setCurrentPhaseEdit: Function;
  legalPhaseTemplateArray: ILegalPhaseTemplateFullObject[];
  setLegalPhaseTemplateArray: Function;
}

export const LegalPhaseEdit: React.FC<IProps> = ({
  currentPhase,
  currentPhaseEdit,
  setCurrentPhaseEdit,
  legalPhaseTemplateArray,
  setLegalPhaseTemplateArray,
}) => {
  const handleSavePhase = () => {
    setLegalPhaseTemplateArray([
      ...legalPhaseTemplateArray.map(x =>
        x.idLegalPhaseTemplate === currentPhaseEdit.idLegalPhaseTemplate
          ? currentPhaseEdit
          : x
      ),
    ]);
    setIsOpenEdit(false);
  };
  const [isOpenEdit, setIsOpenEdit] = useState(
    currentPhase.idLegalPhaseTemplate < 0 &&
      currentPhase.LegalPhaseTemplate === ''
  );
  const [isOpenAddPrecondition, setIsOpenAddPrecondition] = useState(false);

  //
  const [precIdLegalReq, setPrecIdLegalReq] = useState<number | null>(null);

  const hanldeCloseEdit = () => {
    setCurrentPhaseEdit(currentPhase);
    setIsOpenEdit(false);
  };

  const handleAddPredcondigiont = () => {
    if (precIdLegalReq !== null) {
      const testObject = legalPhaseTemplateArray.find(
        x => x.idLegalPhaseTemplate === precIdLegalReq
      );

      if (testObject !== undefined) {
        setCurrentPhaseEdit({
          ...currentPhaseEdit,
          PreconditionArray: [
            ...currentPhaseEdit.PreconditionArray,
            testObject,
          ],
        } as ILegalPhaseTemplateFullObject);
        setIsOpenAddPrecondition(false);
      }
    }
  };

  const handleRemovePrecondition = (idLegalPhaseTemplate: number) => {
    setCurrentPhaseEdit({
      ...currentPhaseEdit,
      PreconditionArray: [
        ...currentPhaseEdit.PreconditionArray.filter(
          x => x.idLegalPhaseTemplate !== idLegalPhaseTemplate
        ),
      ],
    } as ILegalPhaseTemplateFullObject);
  };

  return (
    <>
      <Dialog
        open={isOpenAddPrecondition}
        onClose={() => setIsOpenAddPrecondition(false)}
        maxWidth='md'
      >
        <DialogTitle>Vorgänger hinzufügen</DialogTitle>
        <DialogContent>
          {legalPhaseTemplateArray.filter(
            y => y.Position < currentPhase.Position
          ).length === 0 && (
            <Alert severity='info'>
              Die oberste Phase kann keine Vorgänger haben!
            </Alert>
          )}
          <TextField
            sx={{ mt: 2 }}
            label='Vorgänger'
            value={precIdLegalReq === null ? '' : precIdLegalReq}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setPrecIdLegalReq(Number(event.target.value))
            }
            size='small'
            fullWidth
            disabled={
              legalPhaseTemplateArray.filter(
                y => y.Position < currentPhase.Position
              ).length === 0
            }
            select
          >
            {legalPhaseTemplateArray
              .filter(y => y.Position < currentPhase.Position)
              .map(x => (
                <MenuItem
                  key={`idLegalPhaseTemplate-${x.idLegalPhaseTemplate}`}
                  disabled={
                    currentPhaseEdit.PreconditionArray.filter(
                      y =>
                        y.idLegalPhaseTemplate !==
                        currentPhase.idLegalPhaseTemplate
                    )
                      .map(y => y.idLegalPhaseTemplate)
                      .indexOf(x.idLegalPhaseTemplate) !== -1
                  }
                  value={x.idLegalPhaseTemplate}
                >
                  {x.LegalPhaseTemplate}
                </MenuItem>
              ))}
          </TextField>
        </DialogContent>
        <DialogActions>
          <Button
            variant='outlined'
            onClick={() => setIsOpenAddPrecondition(false)}
          >
            Abbruch
          </Button>
          <Button variant='contained' onClick={handleAddPredcondigiont}>
            Hinzufügen
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={isOpenEdit} onClose={() => {}} maxWidth='lg' fullWidth>
        <DialogTitle>Phase anpassen</DialogTitle>
        <DialogContent>
          <TextField
            label='Phase'
            sx={{ mt: 2 }}
            value={currentPhaseEdit.LegalPhaseTemplate}
            error={currentPhaseEdit.LegalPhaseTemplate === ''}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setCurrentPhaseEdit({
                ...currentPhaseEdit,
                LegalPhaseTemplate: event.target.value,
              })
            }
            size='small'
            fullWidth
          />
          <TextModuleSelector
            key={`type-legalphasedialogedit`}
            floatRight
            idTextModuleCategory={4}
            txt={currentPhaseEdit.InfoText}
            setTxt={(txt: string) =>
              setCurrentPhaseEdit({
                ...currentPhaseEdit,
                InfoText: txt,
              })
            }
          />
          <TextField
            label='Infotext'
            //sx={{mt: 2}}
            value={
              currentPhaseEdit.InfoText === null
                ? ''
                : currentPhaseEdit.InfoText
            }
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              event.target.value === ''
                ? setCurrentPhaseEdit({
                    ...currentPhaseEdit,
                    InfoText: null,
                  })
                : setCurrentPhaseEdit({
                    ...currentPhaseEdit,
                    InfoText: event.target.value,
                  })
            }
            size='small'
            fullWidth
            multiline
            rows={3}
          />

          <Typography variant='h6' sx={{ mt: 3 }}>
            Vorgänger
            <IconButton
              sx={{ float: 'right' }}
              onClick={() => {
                setPrecIdLegalReq(null);
                setIsOpenAddPrecondition(true);
              }}
            >
              <Add />
            </IconButton>
          </Typography>

          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Vorgänger</TableCell>
                <TableCell sx={{ maxWidth: 30 }}>Aktionen</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {currentPhaseEdit.PreconditionArray.map(x => (
                <TableRow>
                  <TableCell>{x.LegalPhaseTemplate}</TableCell>
                  <TableCell>
                    <IconButton
                      size='small'
                      onClick={() =>
                        handleRemovePrecondition(x.idLegalPhaseTemplate)
                      }
                    >
                      <Delete />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' onClick={hanldeCloseEdit}>
            Abbruch
          </Button>
          <Button
            variant='contained'
            onClick={handleSavePhase}
            disabled={currentPhaseEdit.LegalPhaseTemplate === ''}
          >
            Übernehmen
          </Button>
        </DialogActions>
      </Dialog>
      <Tooltip title='Phase bearbeiten'>
        <IconButton
          size='small'
          onClick={() => {
            setCurrentPhaseEdit(currentPhase);
            setIsOpenEdit(true);
          }}
        >
          <Edit />
        </IconButton>
      </Tooltip>
    </>
  );
};
